import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_FEATURES = restRequest("FEATURE.GET_FEATURES");
export const GET_USERS = restRequest("COMPANY_ANALYTICS.GET_USERS");
export const GET_MACHINES = restRequest("COMPANY_ANALYTICS.GET_MACHINES");
export const GET_EQUIPMENTS = restRequest("COMPANY_ANALYTICS.GET_EQUIPMENTS");
export const GET_VEHICLE_ALERTS = restRequest(
    "COMPANY_ANALYTICS.GET_VEHICLE_ALERTS"
);
export const GET_USER_DEVICE_INFO = restRequest(
    "COMPANY_ANALYTICS.GET_USER_DEVICE_INFO"
);
export const GET_REPORT_TITLES = restRequest(
    "COMPANY_ANALYTICS.GET_REPORT_TITLES"
);
export const GET_DEPARTMENTS = restRequest("COMPANY_ANALYTICS.GET_DEPARTMENTS");
export const GET_TOOLBOX = restRequest("COMPANY_ANALYTICS.GET_TOOLBOX");
export const GET_TOOLBOX_TITLES = restRequest(
    "COMPANY_ANALYTICS.GET_TOOLBOX_TITLES"
);
export const GET_ALL_REPORTS = restRequest("COMPANY_ANALYTICS.GET_ALL_REPORTS");
export const GET_JOB_PACKS = restRequest("COMPANY_ANALYTICS.GET_JOB_PACKS");

export const SET_MONTH = "COMPANY_ANALYTICS.SET_MONTH";
export const SET_YEAR = "COMPANY_ANALYTICS.SET_YEAR";
export const GET_REPORTS = restRequest("COMPANY_ANALYTICS.GET_REPORTS");

export const GET_AREAS = restRequest("VRCORE.JOB_PACK_WIDGETS.JOB_PACK_ASSIGNEES_ARRAY_LIST.GET_AREAS");
